const labels = {
  All: { 'See the offering': 'Teklifi gör' },
  FacilityDetails: { 'Ref: Page title': 'Tesis detayları', 'Ref: Review': 'Gözden Geçir' },
  FacilitiesList: { 'Ref: Page title': 'Tesisler', 'Ref: See details': 'Ayrıntılara Bakın' },
};
export default labels;
